import Home from 'pages/Home';
import TripReport from 'pages/TripReport';
import Page00 from 'pages/Page00';
import Page01 from 'pages/Page01';

const assetUrl = 'https://assets.foxriot.com/website';

const Pages = [<Page00 assetUrl={assetUrl} />, <Page01 assetUrl={assetUrl} />];

export { Page00, Home, Pages, assetUrl, TripReport };
